import { jsx as _jsx } from "react/jsx-runtime";
export const WarningIcon = (props) => {
    return (_jsx("svg", { width: "48", height: "48", viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: _jsx("path", { d: "M2 42H46L24 4L2 42ZM8.94 38L24 11.98L39.06 38H8.94ZM22 32H26V36H22V32ZM22 20H26V28H22V20Z", fill: "#FF8600" }) }));
};
